import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { UtilityFunctions } from '../../utils/UtilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { actionCreators, State } from "../../store";
import { cookieService, userService } from '../../_services';
import { STRING_CONSTANTS } from '../../utils/constants/stringConstants';
import SuccessToast from '../../components/successToast';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { checkData } from "../../utils/checkData";
import { api } from "../../middleware/api";
import selectPlan_5 from '../Signup/selectPlan_5';
import { useWhitelabel } from '../../context/WhitelabelContext';
import "../../styles/mploiBrand.css";

// Styles object
const styles = {
    container: {
        backgroundColor: '#F2F2F2',
        minHeight: '100vh',
    },
    topBar: {
        background: '#FFFFFF',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
    },
    topBarTitle: {
        color: '#0D0C0C',
        margin: 0,
        fontSize: '24px',
        fontWeight: '500',
    },
    blueBox: {
        background: '#FFFFFF',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px',
    },
    whiteText: {
        color: '#0D0C0C',
    },
    mutedText: {
        color: 'rgba(0, 0, 0, 0.6)',
    },
    affiliateCodeBox: {
        background: 'linear-gradient(135deg, rgba(255, 74, 10, 0.12) 0%, rgba(148, 252, 79, 0.16) 100%)',
        borderRadius: '12px',
        padding: '30px',
        textAlign: 'center',
        marginBottom: '24px',
        border: '1px solid rgba(255, 74, 10, 0.3)',
    },
    affiliateCode: {
        fontSize: '36px',
        fontWeight: '700',
        color: '#FF4A0A',
        letterSpacing: '3px',
        margin: '10px 0',
    },
    copyButton: {
        backgroundColor: 'rgba(255, 74, 10, 0.1)',
        border: '1px solid #FF4A0A',
        color: '#FF4A0A',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        marginLeft: '15px',
        transition: 'all 0.3s ease',
    },
    urlBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#FFFFFF',
        borderRadius: '6px',
        padding: '12px 20px',
        marginTop: '20px',
    },
    urlText: {
        color: '#0D0C0C',
        fontSize: '16px',
        marginRight: '10px',
        fontFamily: 'monospace',
    },
    table: {
        width: '100%',
        color: '#0D0C0C',
        borderCollapse: 'separate',
        borderSpacing: '0 8px',
    },
    tableHeader: {
        color: 'rgba(0, 0, 0, 0.6)',
        fontWeight: '500',
        padding: '15px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        textAlign: 'left',
    },
    tableCell: {
        padding: '15px',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        color: '#0D0C0C',
    },
    badge: {
        padding: '6px 12px',
        borderRadius: '4px',
        fontWeight: '500',
        display: 'inline-block',
    },
    pendingBadge: {
        backgroundColor: 'rgba(255, 193, 7, 0.2)',
        color: '#ffc107',
    },
    confirmedBadge: {
        backgroundColor: 'rgba(40, 167, 69, 0.2)',
        color: '#28a745',
    },
    button: {
        padding: '8px 16px',
        borderRadius: '4px',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: '#0D0C0C',
    },
    primaryButton: {
        backgroundColor: '#007bff',
    },
    marketingItem: {
        padding: '15px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    marketingItemTitle: {
        color: '#0D0C0C',
        fontSize: '16px',
        fontWeight: '500',
    },
    marketingItemDescription: {
        color: 'rgba(0, 0, 0, 0.6)',
        fontSize: '14px',
        marginTop: '5px',
    },
    infoBox: {
        backgroundColor: 'rgba(0, 123, 255, 0.1)',
        border: '1px solid rgba(0, 123, 255, 0.3)',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px',
    },
    infoTitle: {
        color: '#0D0C0C',
        fontSize: '18px',
        marginBottom: '15px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    infoPoint: {
        display: 'flex',
        marginBottom: '10px',
    },
    infoIcon: {
        color: '#FF4A0A',
        marginRight: '10px',
        fontSize: '16px',
    },
    infoText: {
        color: 'rgba(0, 0, 0, 0.75)',
    },
    statsCard: {
        textAlign: 'center',
        padding: '20px',
    },
    statsNumber: {
        fontSize: '36px',
        fontWeight: '700',
        color: '#FF4A0A',
        marginBottom: '5px',
    },
    statsLabel: {
        color: 'rgba(0, 0, 0, 0.6)',
        fontSize: '14px',
    },
    contactButton: {
        backgroundColor: 'rgba(255, 74, 10, 0.1)',
        border: '1px solid #FF4A0A',
        color: '#FF4A0A',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        transition: 'all 0.3s ease',
    },
    settingsButton: {
        backgroundColor: '#FF4A0A',
        color: '#0D0C0C',
        padding: '10px 20px',
        borderRadius: '4px',
        border: 'none',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
    },
    videoContainer: {
        position: 'relative',
        width: '100%',
        maxWidth: '560px',
        margin: '15px 0',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    videoThumbnail: {
        width: '100%',
        height: 'auto',
        borderRadius: '8px',
    },
    playButton: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60px',
        height: '60px',
        backgroundColor: 'rgba(255, 74, 10, 0.8)',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    playIcon: {
        width: 0,
        height: 0,
        borderTop: '10px solid transparent',
        borderBottom: '10px solid transparent',
        borderLeft: '18px solid #F2F2F2',
        marginLeft: '5px',
    },
    downloadButton: {
        backgroundColor: '#FF4A0A',
        color: '#0D0C0C',
        padding: '12px 24px',
        borderRadius: '4px',
        border: 'none',
        fontWeight: '600',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        margin: '20px auto',
        fontSize: '16px',
        transition: 'all 0.3s ease',
    },
    loginButton: {
        backgroundColor: '#FFFFFF',
        color: '#0D0C0C',
        padding: '6px 12px',
        borderRadius: '4px',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        cursor: 'pointer',
        fontSize: '14px',
        marginLeft: '10px',
    }
};

// Marketing materials data with added videos and download
const MARKETING_MATERIALS = [
    {
        id: 1,
        title: 'Marketing Materials Pack',
        description: 'Complete set of marketing materials including logos, banners, drops, comparisons, and more.',
        url: '/assets/affiliate/MPLOIAccountsReceivableAffiliateMarketing.zip',
        type: 'download'
    },
    {
        id: 2,
        title: 'Short Description',
        description: 'A concise overview of the product for quick pitches.',
        content: 'AI-powered collection calls that recover outstanding invoices automatically, saving you time and improving cash flow.',
        type: 'text'
    },
    {
        id: 3,
        title: 'Long Description',
        description: 'Detailed explanation of features and benefits.',
        content: 'Our Invoice Chaser revolutionizes how businesses handle collections. The AI-powered system automatically calls customers with overdue invoices, using natural conversation to arrange payments. With seamless integration to accounting platforms, customizable voice and personality settings, and detailed analytics, it reduces your admin workload while improving cash flow. The system handles follow-ups, payment arrangements, and even difficult conversations - all without requiring additional staff.',
        type: 'text'
    },
    {
        id: 4,
        title: 'Product Demo Video - Baz from accounts',
        description: 'See Invoice Chaser in action with this comprehensive demo.',
        url: 'https://www.youtube.com/watch?v=nliPgfKz1Os',
        thumbnailUrl: 'https://img.youtube.com/vi/nliPgfKz1Os/maxresdefault.jpg',
        type: 'video'
    },
    {
        id: 5,
        title: 'Human vs AI - Invoice chaser demo',
        description: 'See a challenge vs AI.',
        url: 'https://youtu.be/W2J5h5vhAfU',
        thumbnailUrl: 'https://img.youtube.com/vi/W2J5h5vhAfU/maxresdefault.jpg',
        type: 'video'
    },
    {
        id: 6,
        title: 'How good is Steve from accounts?',
        description: 'See a challenge vs AI.',
        url: 'https://youtu.be/psdciFVMNfY',
        thumbnailUrl: 'https://img.youtube.com/vi/psdciFVMNfY/maxresdefault.jpg',
        type: 'video'
    },
];

const ARAffiliates = (props) => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const [userData, setUserData] = useState(null);
    const { setUnreadNotificationCount } = bindActionCreators(actionCreators, dispatch);
    
    // Whitelabel branding
    const whitelabel = useWhitelabel();
    const productName = whitelabel?.productName || 'MPLOI Invoice Chaser';
    const brandName = whitelabel?.brandName || 'MPLOI';
    const referralBaseUrl = whitelabel?.referralBaseUrl || 'https://core.mploi.com/r/';
    const wlLogoSrc = whitelabel?.logoSrc;
    const [showGuestAccessPrompt, setShowGuestAccessPrompt] = useState(false);
    const [unreadMsgCount, setUnreadMsgCount] = useState(0);
    const user = cookieService?.getCookie(STRING_CONSTANTS?.cookieStrings?.user);
    const isUserLoggedIn = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.token);
    
    // Affiliate data
    const [affiliateCode, setAffiliateCode] = useState('');
    const [affiliateUrl, setAffiliateUrl] = useState(``);
    const [referrals, setReferrals] = useState([]);
    const [copiedCode, setCopiedCode] = useState(false);
    const [copiedUrl, setCopiedUrl] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    
    // Stats
    const [stats, setStats] = useState({
        totalReferrals: 0,
        paidReferrals: 0,
        totalCommission: 0
    });

    const { resetState, closeOnlineOfflineSocket } = bindActionCreators(
      actionCreators,
      dispatch
    );
    
    const handleLogout = (e) => {
      e.preventDefault();
      closeOnlineOfflineSocket(true);
      userService
        .logout()
        .then((res) => {
          api
            .deleteApi("device-token/", {
              deviceType: "WEB",
              token: `${cookieService.getCookie("fcm")}`,
            })
            .then((res) => {
              cookieService.removeAllCookies();
              props.history.push(STRING_CONSTANTS.navigationString.login);
              resetState();
            })
            .catch((e) => {
              cookieService.removeAllCookies();
              props.history.push(STRING_CONSTANTS.navigationString.login);
              resetState();
            });
        })
        .catch((err) => {
          checkData(props, "/", err);
        });
    };

    // Fetch affiliate data from API
    const fetchAffiliateData = async () => {
        setIsLoading(true);
        try {
            // Get user data first
            const userData = await userService.getUserData();
            cookieService.saveCookie(STRING_CONSTANTS.cookieStrings.user, userData);
            setUnreadNotificationCount(userData?.user?.unreadNotificationCount);

            // Extract affiliate code from referral link
            setUserData(userData);

            // Get referrals data
            const affiliateResponse = await userService.aiRequest({
                method: 'get-affiliate-data',
                data: {  }  // Limit to 50 most recent interactions
            });
            console.log("Affiliate data fetched successfully", affiliateResponse);
            if (affiliateResponse && affiliateResponse.data) {
                setReferrals(affiliateResponse.data.referrals || []);

                const code = affiliateResponse.data.code || '';
                setAffiliateCode(code);
                setAffiliateUrl(`${referralBaseUrl}${code}`);
    
                setStats({
                    totalReferrals: affiliateResponse.data.totalReferrals || 0,
                    paidReferrals: affiliateResponse.data.paidReferrals || 0,
                    totalCommission: affiliateResponse.data.totalCommission || 0,
                });
            }

        } catch (error) {
            console.error("Error fetching affiliate data:", error);
            // If API fails, use empty data
            setReferrals([]);
            setStats({
                totalReferrals: 0,
                confirmedReferrals: 0,
                totalCommission: 0
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isUserLoggedIn) {
            fetchAffiliateData();
        }
    }, []);

    const handleCopyCode = () => {
        setCopiedCode(true);
        setTimeout(() => setCopiedCode(false), 2000);
        SuccessToast("Success", "Affiliate code copied to clipboard!");
    };

    const handleCopyUrl = () => {
        setCopiedUrl(true);
        setTimeout(() => setCopiedUrl(false), 2000);
        SuccessToast("Success", "Affiliate URL copied to clipboard!");
    };

    const handleContactCustomer = (referral) => {
        SuccessToast("Contact Initiated", `Contacting ${referral.contactName} from ${referral.companyName}`);
    };
    
    const handleLoginToAccount = (referral) => {
        SuccessToast("Login", `Logging into ${referral.companyName}'s demo account`);
    };
    
    const handleVideoClick = (videoUrl) => {
        window.open(videoUrl, '_blank');
    };
    
    const handleDownload = (url) => {
        SuccessToast("Download Started", "Your marketing materials pack is downloading");
        window.location.href = url;
    };
    
    const navigateToSettings = () => {
        props.history.push('/ar/affiliate/settings');
    };

    return (
        <section className="main-dashboard-wrap mploiBrand" style={styles.container}>
            <Helmet>
                <title>{brandName}: Affiliate Program Dashboard</title>
            </Helmet>
            <div id="wrapper" style={{ height: "100vh" }}>
                {/* Sidebar */}
                <ul className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${state.common.showSidebarOnMobileView ? "active" : ""}`} id="accordionSidebar">
                    <div>
                        <Link style={{ pointerEvents: "none" }} className="sidebar-brand d-flex align-items-center justify-content-center" to="#">
                            <img src={wlLogoSrc || (UtilityFunctions.getImageURL() + "db-logo.svg")} alt="Logo" />
                        </Link>
                        {!user?.user?.isAccountsSignup && <li className="nav-item">
                            <Link className="nav-link" to="/ar/affiliate/dashboard">
                                <img src={UtilityFunctions.getImageURL() + "home-icon-blank-white.svg"} alt="" />
                                <img src={UtilityFunctions.getImageURL() + "home-icon-fill-green.svg"} alt="" />
                            </Link>
                        </li>}
                    </div>

                    <div>
                        <li className='d-grid justify-content-center gap-2 text-white'>
                            <span style={{ cursor: "pointer" }}
                                onClick={handleLogout}
                            >
                                Logout
                            </span>
                        </li>
                    </div>
                </ul>

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <br />
                        {/* Top Bar */}
                        {/* <div style={styles.topBar}>
                            <h1 style={styles.topBarTitle}>{productName} Affiliate Program</h1>
                            <div>
                                <button 
                                    style={styles.settingsButton} 
                                    onClick={navigateToSettings}
                                >
                                    Demo Accounts
                                </button>
                                &nbsp;&nbsp;
                                <button 
                                    style={styles.settingsButton} 
                                    onClick={navigateToSettings}
                                >
                                    Affiliate Settings
                                </button>
                            </div>
                        </div> */}

                        {/* Top Bar with Affiliate Information */}
                        <div style={{
                            background: '#FFFFFF',
                            padding: '24px',
                            borderRadius: '12px',
                            marginBottom: '24px',
                            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                            border: '1px solid rgba(255, 74, 10, 0.2)',
                        }}>
                            <div className="row align-items-center">
                                <div className="col-lg-8">
                                    <h1 style={{...styles.whiteText, fontSize: '28px', marginBottom: '12px', fontWeight: '600'}}>
                                        {productName} Affiliate Program
                                    </h1>
                                    <p style={{...styles.whiteText, opacity: '0.8', fontSize: '16px', lineHeight: '1.6'}}>
                                        Share your unique affiliate link with potential customers. When they sign up for {productName}, 
                                        you'll earn <span style={{color: '#FF4A0A', fontWeight: '600'}}>50% of their first monthly payment</span> as commission.
                                        Track your referrals and earnings directly from this dashboard.
                                    </p>
                                    
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginTop: '16px',
                                        background: 'rgba(255, 74, 10, 0.1)',
                                        padding: '12px 16px',
                                        borderRadius: '8px',
                                        border: '1px solid rgba(255, 74, 10, 0.3)'
                                    }}>
                                        <div style={{marginRight: '12px'}}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM11 7H13V13H11V7ZM11 15H13V17H11V15Z" fill="#FF4A0A"/>
                                            </svg>
                                        </div>
                                        <p style={{...styles.whiteText, margin: 0, fontSize: '18px'}}>
                                            Your affiliate link: <span style={{fontWeight: '500', color: '#FF4A0A'}}>{affiliateUrl || 'Loading...'}</span>
                                            <CopyToClipboard text={affiliateUrl} onCopy={handleCopyUrl}>
                                                <button style={{
                                                    ...styles.copyButton, 
                                                    marginLeft: '12px',
                                                    padding: '4px 12px',
                                                    fontSize: '13px'
                                                }}>
                                                    {copiedUrl ? 'Copied!' : 'Copy Link'}
                                                </button>
                                            </CopyToClipboard>
                                        </p>
                                    </div>
                                </div>
                                
                                <div className="col-lg-4">
                                    <div style={{
                                        background: '#FFFFFF',
                                        borderRadius: '10px',
                                        padding: '20px',
                                        border: '1px solid rgba(0, 0, 0, 0.1)'
                                    }}>
                                        <h4 style={{...styles.whiteText, fontSize: '18px', marginBottom: '16px', fontWeight: '500'}}>
                                            Affiliate Options
                                        </h4>
                                        
                                        <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
                                            <button 
                                                style={{
                                                    backgroundColor: 'rgba(255, 74, 10, 0.1)',
                                                    color: '#FF4A0A',
                                                    padding: '12px 16px',
                                                    borderRadius: '6px',
                                                    border: '1px solid rgba(255, 74, 10, 0.3)',
                                                    fontWeight: '500',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    textAlign: 'left'
                                                }}
                                                onClick={navigateToSettings}
                                            >
                                                <span>Adjust Settings</span>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.3 5.2L8 10.5L2.7 5.2L1.3 6.6L8 13.3L14.7 6.6L13.3 5.2Z" fill="#FF4A0A"/>
                                                </svg>
                                            </button>
                                            
                                            <button 
                                                style={{
                                                    backgroundColor: 'rgba(255, 74, 10, 0.1)',
                                                    color: '#FF4A0A',
                                                    padding: '12px 16px',
                                                    borderRadius: '6px',
                                                    border: '1px solid rgba(255, 74, 10, 0.3)',
                                                    fontWeight: '500',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    textAlign: 'left'
                                                }}
                                                onClick={() => props.history.push('/ar/affiliate/demos')}
                                            >
                                                <span>Manage Demo Accounts</span>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.3 5.2L8 10.5L2.7 5.2L1.3 6.6L8 13.3L14.7 6.6L13.3 5.2Z" fill="#FF4A0A"/>
                                                </svg>
                                            </button>
                                            
                                            <button 
                                                style={{
                                                    backgroundColor: '#FF4A0A',
                                                    color: '#0D0C0C',
                                                    padding: '12px 16px',
                                                    borderRadius: '6px',
                                                    border: 'none',
                                                    fontWeight: '600',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between'
                                                }}
                                                onClick={() => handleDownload('/assets/affiliate/MPLOIAccountsReceivableAffiliateMarketing.zip')}
                                            >
                                                <span>Download Marketing Pack</span>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12ZM0 16V11H2V14H14V11H16V16H0Z" fill="#F2F2F2"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Main Content */}
                        <div className="container-fluid">
                            {/* Affiliate Code Section */}
                            {/* <div style={styles.affiliateCodeBox}>
                                <h3 style={styles.whiteText}>Your Affiliate Code</h3>
                                <div style={styles.affiliateCode}>{affiliateCode || 'Loading...'}</div>
                                <CopyToClipboard text={affiliateCode} onCopy={handleCopyCode}>
                                    <button style={styles.copyButton}>
                                        {copiedCode ? 'Copied!' : 'Copy Code'}
                                    </button>
                                </CopyToClipboard>
                                
                                <div style={styles.urlBox}>
                                    <span style={styles.urlText}>{affiliateUrl || 'Loading...'}</span>
                                    <CopyToClipboard text={affiliateUrl} onCopy={handleCopyUrl}>
                                        <button style={styles.copyButton}>
                                            {copiedUrl ? 'Copied!' : 'Copy URL'}
                                        </button>
                                    </CopyToClipboard>
                                </div>
                            </div> */}

                            {/* Stats Cards */}
                            <div className="row mb-4">
                                <div className="col-xl-4 col-md-4">
                                    <div style={styles.blueBox}>
                                        <div style={styles.statsCard}>
                                            <div style={styles.statsNumber}>
                                                {isLoading ? '...' : stats.totalReferrals}
                                            </div>
                                            <div style={styles.statsLabel}>Total Referrals</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-4">
                                    <div style={styles.blueBox}>
                                        <div style={styles.statsCard}>
                                            <div style={styles.statsNumber}>
                                                {isLoading ? '...' : stats.paidReferrals}
                                            </div>
                                            <div style={styles.statsLabel}>Paid Referrals</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-4">
                                    <div style={styles.blueBox}>
                                        <div style={styles.statsCard}>
                                            <div style={styles.statsNumber}>
                                                {isLoading ? '...' : `$${stats.totalCommission.toFixed(2)}`}
                                            </div>
                                            <div style={styles.statsLabel}>Total Commission</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Referrals Table */}
                            <div style={styles.blueBox}>
                                <h3 style={{...styles.whiteText, marginBottom: '20px'}}>
                                    Your Referrals
                                </h3>
                                <div className="table-responsive">
                                    {isLoading ? (
                                        <p style={styles.whiteText}>Loading referrals data...</p>
                                    ) : referrals.length > 0 ? (
                                        <table style={styles.table}>
                                            <thead>
                                                <tr>
                                                    <th style={styles.tableHeader}>Status</th>
                                                    <th style={styles.tableHeader}>Referred</th>
                                                    <th style={styles.tableHeader}>Company</th>
                                                    <th style={styles.tableHeader}>Contact</th>
                                                    <th style={styles.tableHeader}>Commission</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {referrals.map(referral => (
                                                    <tr key={referral.id}>
                                                        <td style={styles.tableCell}>
                                                            <span style={{
                                                                ...styles.badge,
                                                                ...((referral.status === 'PAID' || referral.status === 'CONFIRMED') ? styles.confirmedBadge : styles.pendingBadge)
                                                            }}>
                                                                {referral.status === 'CONFIRMED' ? 'CUSTOMER PAID' : referral.status === 'PAID' ? 'COMMISSION PAID' : referral.status}
                                                            </span>
                                                        </td>
                                                        <td style={styles.tableCell}>
                                                            {moment(referral.dateReferred || referral.createdAt).format('DD/MM/YYYY')}
                                                        </td>
                                                        <td style={styles.tableCell}>{referral.companyName}</td>
                                                        <td style={styles.tableCell}>
                                                            <div>{referral.contactName}</div>
                                                            <div style={styles.mutedText}>{referral.email}</div>
                                                        </td>
                                                        <td style={styles.tableCell}>
                                                            {referral.commission > 0
                                                                ? <>
                                                                    {`$${referral.commission.toFixed(2)}`}
                                                                    {referral.status !== 'PAID' && <div style={styles.mutedText}>awaiting payout</div>}
                                                                    {referral.paidAt && <div style={styles.mutedText}>paid {moment(referral.paidAt).format('DD/MM/YYYY')}</div>}
                                                                  </>
                                                                : '—'}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <p style={styles.whiteText}>No referrals found. Start sharing your affiliate link to earn commissions!</p>
                                    )}
                                </div>
                            </div>

                            {/* Marketing Materials Section */}
                            <div style={styles.blueBox}>
                                <h3 style={{...styles.whiteText, marginBottom: '20px'}}>
                                    Marketing Materials
                                </h3>
                                
                                {MARKETING_MATERIALS.map((material) => (
                                    <div key={material.id} style={styles.marketingItem}>
                                        <div style={{width: material.type === 'video' ? '70%' : 'auto'}}>
                                            <h4 style={styles.marketingItemTitle}>{material.title}</h4>
                                            <p style={styles.marketingItemDescription}>{material.description}</p>
                                            
                                            {material.type === 'text' && (
                                                <div style={{
                                                    backgroundColor: '#FFFFFF',
                                                    padding: '15px',
                                                    borderRadius: '6px',
                                                    marginTop: '10px',
                                                    color: '#0D0C0C'
                                                }}>
                                                    {material.content}
                                                </div>
                                            )}
                                            
                                            {material.type === 'video' && (
                                                <div 
                                                    style={styles.videoContainer}
                                                    onClick={() => handleVideoClick(material.url)}
                                                >
                                                    <img 
                                                        src={material.thumbnailUrl} 
                                                        alt={material.title}
                                                        style={styles.videoThumbnail}
                                                    />
                                                    <div style={styles.playButton}>
                                                        <div style={styles.playIcon}></div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        
                                        {material.type === 'download' && (
                                            <button 
                                                style={styles.downloadButton}
                                                onClick={() => handleDownload(material.url)}
                                            >
                                                <span>Download Marketing Pack</span>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12ZM0 16V11H2V14H14V11H16V16H0Z" fill="#F2F2F2"/>
                                                </svg>
                                            </button>
                                        )}
                                        
                                        {material.type === 'video' && (
                                            <a 
                                                href={material.url} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                style={styles.copyButton}
                                            >
                                                Watch Video
                                            </a>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Affiliate Program Info */}
                            <div style={styles.infoBox}>
                                <h3 style={styles.infoTitle}>
                                    How Our Affiliate Program Works
                                </h3>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>Commission:</strong> You earn 50% of your referral's first monthly payment, ex GST, when they subscribe to {productName}. Your referral pays the standard price.
                                    </p>
                                </div>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>Tracking:</strong> Anyone who signs up through your link is linked to you at signup and stays linked, so their subscription is credited to you whenever they pay.
                                    </p>
                                </div>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>Payment Terms:</strong> Commissions are paid monthly for all confirmed referrals from the previous month.
                                    </p>
                                </div>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>Confirmation Process:</strong> Referrals are confirmed after they complete their first month's subscription.
                                    </p>
                                </div>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>Marketing Support:</strong> Use our provided marketing materials to promote {brandName} effectively.
                                    </p>
                                </div>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>Tracking:</strong> All referrals are automatically tracked through your unique affiliate code.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ARAffiliates;